import React from 'react';
import { StatusTag } from '../../../components/common/page';
import { expirationStatus, expirationTagText, formatExpirationDate, parseExpirationDate } from './expiration';

/**
 * An inventory expiration date (es-VE) with a warning tag when it is close and a danger tag
 * once it has passed. Renders nothing without a valid date.
 */
export function ExpirationDate({ value, warningDays }) {
    const formatted = formatExpirationDate(value);
    if (!formatted) return null;
    const state = expirationStatus(value, { warningDays });
    const tag = expirationTagText(state);
    return (
        <span className="inline-flex flex-wrap items-center gap-2">
            <span className="text-sm tabular-nums text-surface-700">{formatted}</span>
            {tag && <StatusTag tone={state.status === 'expired' ? 'danger' : 'warning'}>{tag}</StatusTag>}
        </span>
    );
}

/**
 * "Vencimiento" column for the inventory table (rows from buildInventoryRows, which carry
 * `expirationDate`). Sorts by date with undated rows last.
 * @param {number} warningDays
 */
export function expirationColumn(warningDays) {
    const time = (row) => parseExpirationDate(row?.expirationDate)?.getTime() ?? Number.POSITIVE_INFINITY;
    return {
        title: 'Vencimiento',
        dataIndex: 'expirationDate',
        key: 'expirationDate',
        width: 220,
        render: (value) => <ExpirationDate value={value} warningDays={warningDays} />,
        sorter: (a, b) => time(a) - time(b)
    };
}
